import React, { Component } from "react";
import { Frame, FrameRiskTree, RiskColorMap, TSData } from "./type";
import { RiskDataManager } from "./dataProp";

import RadialBarFrame from "./frames/RadialBarFrame";
import ScalableFrame from "./frames/ScalableFrame";

type Props = {
  thumbnail: Frame;
  frames: Frame[];
  color: RiskColorMap;
  riskData: TSData;
  sceneRisk: FrameRiskTree;
  sceneX: number;
  sceneH: number;
  sceneId: number;
  callbackFn: (currentTime: number) => void;
};

type State = {
  R_RATIO: number;
  focusRiskLabel: string | null;
};

export default class Scene extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      R_RATIO: 0.4,
      focusRiskLabel: null,
    };
  }

  setFocusRiskLabel(riskLabel: string) {
    this.setState({
      focusRiskLabel: riskLabel,
    });
  }

  render() {
    const {
      thumbnail,
      frames,
      riskData,
      color,
      sceneRisk,
      sceneX,
      sceneH,
      sceneId,
    } = this.props;
    const { R_RATIO, focusRiskLabel } = this.state;
    const riskDataManager = new RiskDataManager(riskData);
    const sceneFrames = frames.map((frame) => {
      return (
        <div
          className="scene-frame-wrapper"
          key={`scene-${thumbnail.scene}-frame-${frame.time}`}
          style={{
            position: "absolute",
            left: `${frame.value[0]}px`,
            top: `${(sceneH - frame.size[1]) / 2}px`,
          }}
          onClick={() => {
            this.props.callbackFn(frame.time);
          }}
        >
          <ScalableFrame
            frame={frame}
            frameScale={sceneH / frame.size[1]}
            frameRiskTree={riskDataManager.getFrameRiskTree(`${frame.time}`)}
            focusRiskLabel={focusRiskLabel}
          />
        </div>
      );
    });
    return (
      <div
        className="scene"
        style={{
          position: "relative",
          background: "#fff",
          marginBottom: "4px",
          height: `${sceneH}px`,
          width: "100%",
        }}
      >
        <RadialBarFrame
          sceneX={sceneX}
          sceneH={sceneH}
          frame={thumbnail}
          frameRiskTree={sceneRisk}
          riskColorMap={color}
          R_RATIO={sceneId < 3 ? R_RATIO : 0}
          riskEncode={"mixed"}
          callbackFn={(riskLabel: string) => this.setFocusRiskLabel(riskLabel)}
        />
        {sceneFrames}
      </div>
    );
  }
}
